var _path, _rect, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailDescription(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5347 9.34104L12.3499 9.76579C12.3212 9.83511 12.2726 9.89436 12.2102 9.93605C12.1478 9.97775 12.0745 10 11.9994 10C11.9244 10 11.8511 9.97775 11.7887 9.93605C11.7263 9.89436 11.6777 9.83511 11.649 9.76579L11.4642 9.34104C11.1397 8.59078 10.5458 7.98931 9.79956 7.65525L9.23069 7.40089C9.16181 7.36909 9.10349 7.31823 9.06261 7.25434C9.02172 7.19044 9 7.11618 9 7.04033C9 6.96448 9.02172 6.89022 9.06261 6.82633C9.10349 6.76243 9.16181 6.71158 9.23069 6.67978L9.76836 6.43981C10.5333 6.09683 11.1376 5.47376 11.457 4.69883L11.6466 4.24169C11.6743 4.1705 11.7229 4.10933 11.7859 4.0662C11.849 4.02307 11.9236 4 12 4C12.0765 4 12.1511 4.02307 12.2142 4.0662C12.2772 4.10933 12.3258 4.1705 12.3535 4.24169L12.5431 4.69763C12.862 5.47347 13.4664 6.09746 14.2317 6.44101L14.7706 6.68098C14.8391 6.71292 14.8971 6.76377 14.9378 6.82753C14.9784 6.89129 15 6.96533 15 7.04093C15 7.11654 14.9784 7.19057 14.9378 7.25434C14.8971 7.3181 14.8391 7.36894 14.7706 7.40089L14.2005 7.65405C13.4542 7.9885 12.8603 8.5904 12.5359 9.34104H12.5347ZM13.3172 7.03733C12.7864 6.70348 12.3363 6.25597 11.9994 5.7271C11.6626 6.25597 11.2125 6.70348 10.6817 7.03733C11.2097 7.36369 11.6598 7.80044 11.9994 8.31757C12.3396 7.79948 12.7895 7.36244 13.3172 7.03733Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 2.75,
    width: 12.5,
    height: 13.5,
    rx: 1.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.75,
    y1: 10.25,
    x2: 9.25,
    y2: 10.25,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.75,
    y1: 13.25,
    x2: 13.25,
    y2: 13.25,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailDescription);
export default __webpack_public_path__ + "static/media/detailDescription.4adfea6b8f0e8cedb8d97343305b027f.svg";
export { ForwardRef as ReactComponent };